import React from 'react';
import { Hero } from '../components/Hero';

export const Home = () => {
  return (
    <div className="flex flex-col justify-center">
      <Hero />
    </div>
  );
};
